import "./RaikoLineStepper.scss"


export default function RaikoLineStepper(
	{
		numberOfSteps = 3,
		currentStep = 1,
		onChangeStep
	}) {


	return (
		<div className={"baseLineStepperContainer"}>
			{
				[...Array(numberOfSteps)].map((item, index) => {
					return <div
						className={`lineStepItem ${index + 1 === currentStep ? "lineStepItemActive" : ""}`}
						key={index}
					/>
				})
			}
		</div>
	)

}